// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-select .loader[data-v-17cc0527] svg {\n  stroke: black;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/Select.vue"],"names":[],"mappings":"AAIQ;EACI,aAAA;AAHZ","sourcesContent":["\r\n.app-select {\r\n\r\n    .loader {\r\n        ::v-deep svg {\r\n            stroke: black;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
